import { Box } from '@acv/clearcar-component-lib';

export const ModalContent = ({ children }) => (
  // TODO support overflow in Box
  // TODO support position prop
  <Box isFlexGrow style={{ position: 'relative' }}>
    {children}
  </Box>
);
